module.exports = __webpack_public_path__ + "img/4X2A7837.065c9846.jpeg";